export default "__VITE_ASSET__C_35$_ot__"